export interface RecentUnitView {
  propertyCode: string;
  unitId: string;
  viewedAt: number;
}

const STORAGE_KEY = 'recent_unit_views';
const MAX_RECENT = 6;

export function getRecentUnitViews(): RecentUnitView[] {
  if (typeof window === 'undefined') {
    return [];
  }
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      return [];
    }
    const parsed = JSON.parse(stored) as RecentUnitView[];
    if (!Array.isArray(parsed)) {
      return [];
    }
    return parsed
      .filter(
        (entry) =>
          typeof entry?.propertyCode === 'string' &&
          typeof entry?.unitId === 'string' &&
          typeof entry?.viewedAt === 'number',
      )
      .slice(0, MAX_RECENT);
  } catch {
    return [];
  }
}

export function recordRecentUnitView(input: { propertyCode: string; unitId: string }): void {
  if (typeof window === 'undefined') {
    return;
  }
  const normalized = {
    propertyCode: input.propertyCode.trim().toUpperCase(),
    unitId: input.unitId.trim(),
  };
  if (normalized.propertyCode.length === 0 || normalized.unitId.length === 0) {
    return;
  }
  const current = getRecentUnitViews();
  const filtered = current.filter(
    (entry) =>
      entry.unitId !== normalized.unitId ||
      entry.propertyCode.toUpperCase() !== normalized.propertyCode,
  );
  const next: RecentUnitView[] = [{ ...normalized, viewedAt: Date.now() }, ...filtered].slice(
    0,
    MAX_RECENT,
  );
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
}
